<template>
    <div class="tag-status">
        <CompassTag :color="information.color" :size="size" :icon="information.icon">
            {{ nonNullLabel }}
        </CompassTag>
    </div>
</template>
<script>
import { allStatus, deliveryStatus, incomingPurDocStatus, promotionStatus } from 'Dictionaries/statusColors';

export default {
    props: {
        id: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'medium',
            validator: (value) => ['small', 'medium', 'large'].includes(value),
        },
        type: {
            type: String,
            default: 'default',
            validator: (value) => ['default', 'delivery', 'incomingPurDoc', 'promotion'].includes(value),
        },
    },
    computed: {
        nonNullLabel() {
            return this.label || this.$l10n.__('Inconnu');
        },
        information() {
            const status = this.id.toLowerCase();

            switch (this.type) {
                case 'delivery':
                    return deliveryStatus[status] ?? { color: 'gray', icon: null };
                case 'incomingPurDoc':
                    return incomingPurDocStatus[status] ?? { color: 'gray', icon: null };
                case 'promotion':
                    return promotionStatus[status] ?? { color: 'gray', icon: null };
                default:
                    return allStatus[status] ?? { color: 'gray', icon: null };
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.tag-status {
    align-items: center;
    display: flex;
    height: 100%;
}
</style>
